module.exports = __webpack_public_path__ + "img/recheck.c365316a.svg";